<template>
	<div class="partidaequipamientoFormHeader puiformheader">
	</div>
</template>

<script>
import { PuiFormHeaderMixin } from '@Pui9Components';

export default {
	name: 'partidaequipamiento-form-header',
	mixins: [PuiFormHeaderMixin],
	data() {
		return {
			modelName: 'partidaequipamiento'
		};
	},
	computed: {
	}
}
</script>
